import { PageLoading } from 'embroil/components/loading';

<template>
  <PageLoading @message="Loading game reviews..." @subtitle="Finding the latest reviews and ratings for you" />
</template>
